<template>
    <div class="landing">
        <van-nav-bar
                fixed
                title="签约落地"
                left-arrow
                @click-left="$router.go(-1)">
        </van-nav-bar>
       
        <div class="hhb-view">
            <detail-view v-model="info" :attrs="attrs" :opts="opts"/>
        </div>
    </div>
</template>

<script>
    import DetailView from "@/components/detail/index";
    import {dateFormat} from "@/utils/common-api";

    export default {
        name: "landing",
        components: {DetailView},
        data() {
            return {
                info: {},
                opts: {},
                attrs: [
                    {
                        head: {
                            title: '签约信息'
                        },
                        body: [
                            {
                                type: 'text-right',
                                name: 'signTime',
                                title: '签约时间：'
                            },
                            {
                                type: 'text-right',
                                name: 'htType',
                                title: '合同类型：'
                            },
                            {
                                type: 'text-right',
                                name: 'buildType',
                                title: '建设性质：'
                            },
                            {
                                type: 'text-right',
                                name: 'ysCount',
                                title: '达产营收：'
                            },
                            {
                                type: 'text-right',
                                name: 'zftzCount',
                                title: '中方投资(亿元)：'
                            },
                            {
                                type: 'text-right',
                                name: 'wztzCount',
                                title: '外资(亿元)：'
                            },
                            {
                                type: 'text-right',
                                name: 'jf',
                                title: '甲方：'
                            },
                            {
                                type: 'text-right',
                                name: 'yf',
                                title: '乙方：'
                            },
                            {
                                type: 'text-right',
                                name: 'bf',
                                title: '丙方：'
                            }
                        ]
                    },
                    {
                        head: {
                            title: '相关文件'
                        },
                        body: [
                            {
                                type: 'download',
                                name: 'dataFile',
                                title: '补充材料：',
                                valueKey: 'dataUrl',
                                labelKey: 'dataTitle'
                            }
                        ]
                    }
                ]
            };
        },
        methods: {
            requestData() {
                this.$toast.loading('加载中...');
                this.request({
                    url: "/v1.0/Project/getProjectContact",
                    method: "get",
                    params: {
                        projectId: this.getId
                    },
                }).then((res) => {
                    const {dataFile,signTime,htType,buildType,ysCount,zftzCount,wztzCount,jf,yf,bf} = res.data;
                    this.$set(this.info, 'dataFile', dataFile);
                    this.$set(this.info, 'signTime', dateFormat(signTime));
                    this.$set(this.info, 'htType', htType);
                    this.$set(this.info, 'buildType', buildType);
                    this.$set(this.info, 'ysCount', ysCount);
                    this.$set(this.info, 'zftzCount', zftzCount);
                    this.$set(this.info, 'wztzCount', wztzCount);
                    this.$set(this.info, 'jf', jf);
                    this.$set(this.info, 'yf', yf);
                    this.$set(this.info, 'bf', bf);
                    this.$toast.clear();
                }).catch(() => {
                    this.$toast.clear();
                });
            }
        },
        computed: {
            getId() {
                return this.$route.query.id;
            }
        },
        created() {
            this.requestData();
        }
    }
</script>

<style lang="scss" scoped>
</style>